import { render, staticRenderFns } from "./BannerDiscoverDetail.vue?vue&type=template&id=42a0c433&scoped=true"
import script from "./BannerDiscoverDetail.vue?vue&type=script&lang=js"
export * from "./BannerDiscoverDetail.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BannerDiscoverDetail.vue?vue&type=style&index=1&id=42a0c433&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a0c433",
  null
  
)

export default component.exports